<main class="main rush-bg-default font-inter">
  <div class="gradient-overlay"></div>

  <app-header
    class="absolute"
    *ngIf="showHeader"
    class="relative z-50"
    [isLoggerPage]="isLoggerPage"
  ></app-header>
  <mat-spinner
    color="warn"
    class="spinner !fixed bottom-10 left-[48%] z-10 bg-transparent"
    [strokeWidth]="3"
    [diameter]="30"
    *ngIf="isShowSpinner"
  ></mat-spinner>
  <div class="gradient-overlay absolute inset-0 z-0"></div>
  <div class="page-content">
    <router-outlet></router-outlet>
  </div>
  <app-modal-v2 [showModal]="showProfileModal" title="Profile" (closeEmitter)="closeModal()">
    <app-profile-management class="w-full"></app-profile-management>
  </app-modal-v2>
  <app-modal-v2 [showModal]="showChipsModal" title="Chips" (closeEmitter)="closeChipsModal()">
    <app-chips *ngIf="authenticated" class="w-full"></app-chips>
  </app-modal-v2>

  <app-modal-v2
    [showModal]="showTableInfoModal"
    [title]="tableInfoTitle"
    (closeEmitter)="closeModal()"
  >
    <app-tables-info
      *ngIf="showTableInfoModal"
      [foldCost]="foldCost"
      [buyInCost]="buyInCost"
      [minBet]="minBet"
      [maxBet]="maxBet"
      class="h-96 w-full overflow-auto md:h-full"
    ></app-tables-info>
  </app-modal-v2>
</main>
